<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.club.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.club.list.title"></app-i18n>
      </h1>

      <app-club-list-toolbar></app-club-list-toolbar>
      <app-club-list-filter></app-club-list-filter>
      <app-club-list-table></app-club-list-table>
    </div>
  </div>
</template>

<script>
import ClubListFilter from '@modules/club/components/club-list-filter.vue';
import ClubListTable from '@modules/club/components/club-list-table.vue';
import ClubListToolbar from '@modules/club/components/club-list-toolbar.vue';

export default {
  name: 'app-club-list-page',

  components: {
    [ClubListFilter.name]: ClubListFilter,
    [ClubListTable.name]: ClubListTable,
    [ClubListToolbar.name]: ClubListToolbar,
  },
};
</script>

<style>
</style>
